import { render } from "./SignatoryModal.vue?vue&type=template&id=239218ec&scoped=true"
import script from "./SignatoryModal.vue?vue&type=script&lang=js"
export * from "./SignatoryModal.vue?vue&type=script&lang=js"

import "./SignatoryModal.vue?vue&type=style&index=0&id=239218ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239218ec"]])

export default __exports__